import FreeDay from '@/models/freeDay'

export default {
  namespaced: true,
  state: {
    currentPage: 1,
    count: 0
  },
  actions: {
    async list ({ dispatch, state }, params) {
      return dispatch('list', {modelClass: FreeDay, params: params}, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async retrieve ({ dispatch, state }, id) {
      return dispatch('retrieve', { modelClass: FreeDay, id: id }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async save ({ dispatch, state }, data) {
      return dispatch('save', { modelClass: FreeDay, data: data, id: data.id }, { root: true })
        .then(response => { state.object = response })
        .catch(error => { throw error })
    },
    async delete ({ dispatch, state }, data) {
      return dispatch('delete', { modelClass: FreeDay, data: data }, { root: true })
        .then(response => { state.object = response })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.objects }
  }
}



// WEBPACK FOOTER //
// ./src/store/freeDay.js